export { Text, TextProps } from './Text';
